export default [
  {
      path: "/mallClassFiltrate",
      name: "mallClassFiltrate",
      component: () => import("@parent/views/mall/filtrate/mall-class-filtrate.vue"),
      meta: {
          vx_animate: "none"
      }
  },
  {
    path: "/mallGoodsFiltrate",
    name: "mallGoodsFiltrate",
    component: () => import("@parent/views/mall/filtrate/mall-goods-filtrate.vue"),
    meta: {
        vx_animate: "none"
    }
},
]